import React, { useEffect, useState } from 'react';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import ConversationList from '../../components/chat/conversation-list';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import Loading from '../../components/loading/loading';

// Helpers
import { ConversationListEntry, conversationListEntry } from '../../helpers/conversation-helper';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Services
import ConversationService from '../../services/conversation-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';

const ChatList = () => {
  const [error, setError] = useState(false);
  const [rows, setRows] = useState<ConversationListEntry[]>(null);

  useEffect(() => {
    const currentPersonUuid = new StorageService().getEmployee()?.uuid;
    new SchoolService()
      .getSchoolById(new StorageService().getEmployee().schoolId)
      .then((school) => new ConversationService(school.uuid).listConversations())
      .then((conversations) => setRows(conversations.map((conversation) => conversationListEntry(conversation, currentPersonUuid))))
      .catch(() => setError(true));
  }, []);

  if (error) return <ErrorComponent type='contentFull' />;

  if (!rows) return <Loading type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <ButtonsBar pattern='together' sideAlign='left'>
        <FeatureTitle title='mensagens' />
      </ButtonsBar>

      {rows.length > 0 ? <ConversationList entries={rows} /> : <Empty />}
    </BaseContentContainer>
  );
};

export default ChatList;
